import React from "react";
import DescriptionList from "@comm/DescriptionList";

const { Description } = DescriptionList;

const CardBase = ({ term, column, children, accountInfo, ...restProps }) => (
  <DescriptionList size="large" col={3}>
    <Description term="户名">{accountInfo.accountName}</Description>
    <Description term="银行账号">{accountInfo.account}</Description>
    <Description term="税号">{accountInfo.taxCode}</Description>
    <Description term="开户行">{accountInfo.accountBank}</Description>
  </DescriptionList>
);

export default CardBase;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/CardAccount.js